import React from "react";
import ReactMarkdown from "react-markdown";
import { Sparkles } from "lucide-react";

export const ChatBubble = ({ role, text, pending, index }) => {
  const mine = role === "user";
  return (
    <div className={`flex ${mine ? "justify-end" : "justify-start"} fade-slide-up`} data-testid={`ai-msg-${role}-${index}`}>
      {!mine && (
        <div className="w-8 h-8 shrink-0 mr-2 rounded-full bg-[rgba(230,180,85,0.12)] flex items-center justify-center">
          <Sparkles size={14} className="text-[#E6B455]" />
        </div>
      )}
      <div
        className={`max-w-[82%] rounded-2xl px-4 py-3 text-sm leading-relaxed ${
          mine
            ? "bg-gradient-to-br from-[#E6B455] to-[#B8902F] text-[#0A0F1E] font-medium rounded-br-md"
            : "card-glass gold-border text-[#F7E6B4]/90 rounded-bl-md"
        }`}
      >
        {mine ? (
          text
        ) : text ? (
          <div className="ai-md">
            <ReactMarkdown>{text}</ReactMarkdown>
          </div>
        ) : (
          pending && (
            <span className="flex gap-1 py-1" data-testid="ai-typing">
              {[0, 1, 2].map((i) => (
                <span key={i} className="w-1.5 h-1.5 rounded-full bg-[#E6B455] animate-bounce" style={{ animationDelay: `${i * 0.15}s` }} />
              ))}
            </span>
          )
        )}
      </div>
    </div>
  );
};
